export const SEO_CONFIG = {
  "/": {
    title: "大庆阳光采购服务平台",
    keywords: "大庆阳光采购服务平台",
    description: "大庆阳光采购服务平台。",
  },
  "/porperty/list/xmgg_gyzcjy": {
    title: "大庆阳光采购服务平台",
    keywords: "大庆阳光采购服务平台",
    description: "大庆阳光采购服务平台。",
  },
  "/porperty/detail/xmgg_gyzcjy": {
    initTitle: "大庆阳光采购服务平台",
    title: "{title} - 大庆阳光采购服务平台",
    keywords: "{title} - 大庆阳光采购服务平台",
    description: "{title} - 大庆阳光采购服务平台",
  },
  "/porperty/list/xmgg_zrzyjy": {
    title: "大庆阳光采购服务平台",
    keywords: "大庆阳光采购服务平台",
    description: "大庆阳光采购服务平台。",
  },
  "/porperty/detail/xmgg_zrzyjy": {
    initTitle: "大庆阳光采购服务平台",
    title: "{title} - 大庆阳光采购服务平台",
    keywords: "{title} - 大庆阳光采购服务平台",
    description: "{title} - 大庆阳光采购服务平台",
  },
  "/purchase/list/xmxx": {
    title: "大庆阳光采购服务平台",
    keywords: "大庆阳光采购服务平台",
    description: "大庆阳光采购服务平台。",
  },
  "/purchase/detail/xmxx": {
    initTitle: "大庆阳光采购服务平台",
    title: "{title}｜{region} - 大庆阳光采购服务平台",
    keywords: "{region},{category},采购公告,{orgName},大庆阳光采购服务平台",
    description:
      "{orgName}发布{categoryType}公告，项目：{title}，预算{budget}，项目{status}，更多招采信息关注大庆阳光采购服务平台。",
  },
};

/**
 * 获取当前路由的 SEO 配置
 * @param {string} path 路由路径
 * @param {Object} dynamicData 动态数据
 * @returns {Object} SEO 配置
 */
export function getSEOConfig(path, dynamicData = {}) {
  const cleanPath = path.replace(/\?.*$/, "").replace(/\/$/, "");
  let config = SEO_CONFIG[cleanPath] || SEO_CONFIG["/"];

  if (Object.keys(dynamicData).length > 0) {
    config = replaceDynamicData(config, dynamicData);
  }

  return config;
}

/**
 * 替换动态数据占位符
 */
function replaceDynamicData(config, dynamicData) {
  const result = { ...config };

  // 遍历所有属性进行占位符替换
  Object.keys(result).forEach((key) => {
    if (typeof result[key] === "string") {
      result[key] = replacePlaceholders(result[key], dynamicData);
    }
  });

  return result;
}

// 占位符与对应数据的映射
const PLACEHOLDER_KEYS = [
  "title",
  "region",
  "category",
  "orgName",
  "categoryType",
  "budget",
  "status",
];

/**
 * 替换占位符
 */
function replacePlaceholders(text, data) {
  if (!text) return text;

  let result = text;

  // 处理 title 和 region 的｜分隔符
  if (!data.title) result = result.replace(/\{title\}｜/g, "");
  if (!data.region) result = result.replace(/｜\{region\}/g, "");

  // 替换所有占位符
  PLACEHOLDER_KEYS.forEach((key) => {
    result = result.replace(new RegExp(`\\{${key}\\}`, "g"), data[key] || "");
  });

  // 清理分隔符：删除开头/结尾的分隔符，合并连续的分隔符
  result = result
    .replace(/^[,，、｜]+/, "")
    .replace(/[,，、｜]+$/, "")
    .replace(/,{2,}/g, ",")
    .replace(/，{2,}/g, "，")
    .replace(/\s+/g, " ");

  return result;
}

/**
 * 设置页面 SEO
 * @param {Object} config SEO 配置
 */
export function setPageSEO(config, init) {
  if (!config) return;

  // 设置标题
  if (config.title) {
    document.title = init ? config.initTitle || config.title : config.title;
  }

  // 设置 meta
  setMetaTag("keywords", config.keywords);
  setMetaTag("description", config.description);
}

/**
 * 设置 meta 标签
 */
function setMetaTag(name, content) {
  if (!content) return;

  let meta = document.querySelector(`meta[name="${name}"]`);

  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }

  meta.content = content;
}
